import React, { useEffect, Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import Layout from "../Components/Layout/Body/index";
import ProtectedRoute from "../RouterPath/protectedRoute"; // Import ProtectedRoute

// Route-level code splitting: each page ships in its own chunk instead of
// being bundled eagerly into the main app bundle.
const Login = lazy(() => import("../Pages/Login"));
const TermsAndConditions = lazy(() => import("../Pages/TermsAndConditions/index"));
const PrivacyPolicy = lazy(() => import("../Pages/Privacy/index"));
const PricingPage = lazy(() => import("../Pages/Payment"));
const LoginLandingPage = lazy(() => import("../Pages/LoginLanding"));
const NewEnquiryPage = lazy(() => import("../Pages/NewEnquiry"));
const Home = lazy(() => import("../Pages/Home"));

const RouteFallback = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
    <CircularProgress />
  </Box>
);


const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {
      }
    };

    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, []);

  return (
    <div className="App">
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {/* Public Routes without Layout (no header/menu) */}
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/new-enquiry" element={<NewEnquiryPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<Login />} />

          <Route element={<Layout isDarkTheme={isDarkTheme} />}>
            {/* Public Routes with Layout */}

            <Route path="/" element={<LoginLandingPage />} />
            {/* <Route path="/landing" element={<LandingPage />} /> */}

            {/* <Route path="/enquiry" element={<Enquiry />} /> */}

            {/* Protected Route - Enquiry */}
            <Route element={<ProtectedRoute />}>
              <Route path="/home" element={<Home />} />

              {/* Role-Based Routes */}
              {/* Add more role-based routes as needed */}
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
};
export default RoutePath;
